import http from './http' // needs this file in the same directory

export default {
  balance(){
    return http.get(`/balance`);
  },
  transfer(ammount){
    return http.post('/balance', {ammount: ammount})
  }
}